import axios from 'axios';
import { ElMessage } from 'element-plus';
//Produzione  https://gestionale-scintilla.com/apis/v1/
export default (url = 'https://gestionale-scintilla.com/apis/v1/') => {
  const client = axios.create({
    baseURL: url,
    headers: { 'Access-Control-Allow-Origin': '*' },
  });

  // Prima di questo interceptor ogni errore veniva inghiottito da catch
  // silenziosi: l'utente non aveva alcun feedback. Il login gestisce da sé
  // il 401 (credenziali errate), quindi viene escluso.
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      const isLogin =
        error.config && (error.config.url || '').includes('/user/login');
      if (!isLogin) {
        if (error.response) {
          ElMessage({
            message: `Operazione non riuscita (errore ${error.response.status})`,
            type: 'error',
            grouping: true,
          });
        } else {
          ElMessage({
            message: 'Impossibile contattare il server',
            type: 'error',
            grouping: true,
          });
        }
      }
      return Promise.reject(error);
    }
  );

  return client;
};
